import React, { useState } from "react";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { Checkbox } from "antd";

import { closeTutorial } from "../../stores/nutstat";
import { SubmitButton } from "../CustomFields";

const Footer = () => {
  const dispatch = useDispatch();
  const [checked, onChangeCheck] = useState(
    localStorage.getItem("hideTutorial") === "true"
  );

  const onClose = () => {
    localStorage.setItem("hideTutorial", checked);
    dispatch(closeTutorial());
  };

  return (
    <Container>
      <CheckboxWrapper>
        <Checkbox
          id="nutstatCheckbox"
          defaultChecked={checked}
          onChange={(e) => onChangeCheck(e.target.checked)}
        />
        &nbsp;&nbsp;
        <label htmlFor="nutstatCheckbox">ไม่ต้องแสดงอีก</label>
      </CheckboxWrapper>
      <SubmitButton onClick={onClose}>เข้าใจแล้ว</SubmitButton>
    </Container>
  );
};

export default Footer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Noto Sans Thai, Noto Sans;
`;
const CheckboxWrapper = styled.div`
  margin-bottom: 20px;
`;
